import {
  mapFieldVisibilityToApi,
  readLocalFieldVisibility,
} from './mappers/mapReservationFormSettings'

export default function(api: GlobalFetch) {
  return async function(reservationFormBanner = 1) {
    const fieldVisibility = readLocalFieldVisibility()

    if (!fieldVisibility) {
      return false
    }

    const response = await api.fetch('/api/v2/user/reservationform', {
      body: JSON.stringify({
        reservation_form_settings: mapFieldVisibilityToApi(fieldVisibility),
        reservation_form_banner: reservationFormBanner,
      }),
      method: 'POST',
    })

    return response.status === 200
  }
}
